export default __webpack_public_path__ + "static/media/Months_10.a431f124.png";